import { TabStyled } from './Tab.styles';
import { TabProps } from './types';

/**
 * Tab component.
 */
export const Tab = (props: TabProps) => <TabStyled {...props} />;
